import { Text, View, Image, Link } from '@react-pdf/renderer';

// Constants
import { IMAGES } from '@shared/constants';

// Icons
import { PDFEmailIcon, PDFPhoneIcon, PDFLocationIcon, PDFBirthdayIcon, PDFHrefIcon } from '@/components/pdf-icons';

// Utils
import { getSocialMediaIdentifier } from '@/utils/pdf';
import { wrapText, isEmptyValueArray, formatDateStringToMonthYear } from '@shared/utils';
import { getPDFSocialIcon } from '@/utils/icons';

// Types
import { FormPersonalInfo, PreviewImage } from '@shared/types';

// Tokens
import theme from '@/components/template/resume/Default/tokens';

// Constants
import { SOCIAL_PLATFORMS } from '@/constants/icons';

// Styles
import styles from '../../style';
interface PersonalInfoSectionProps {
  info: FormPersonalInfo & PreviewImage;
  currentAvatar: string;
  hasPersonalInfo: boolean;
}
const PersonalInfoSection = ({
  info,
  currentAvatar,
  hasPersonalInfo
}: PersonalInfoSectionProps) => {
  const {
    name = '',
    title = '',
    email = '',
    phone = '',
    address = '',
    birthday
  } = info || {};
  if (!hasPersonalInfo) return null;
  return <View style={styles.profileContainer} data-sentry-element="View" data-sentry-component="PersonalInfoSection" data-sentry-source-file="PersonalInfo.tsx">
      <View style={styles.profileSection} data-sentry-element="View" data-sentry-source-file="PersonalInfo.tsx">
        <View style={styles.profileImageContainer} data-sentry-element="View" data-sentry-source-file="PersonalInfo.tsx">
          <Image style={styles.profileImage} src={currentAvatar || IMAGES.AVATAR_DEFAULT_PNG} data-sentry-element="Image" data-sentry-source-file="PersonalInfo.tsx" />
        </View>
        {name && <Text style={styles.name}>
            {wrapText(name, {
          width: 10,
          breakAfterFirstSpace: true
        })}
          </Text>}
        {title && <Text style={styles.title}>{title}</Text>}
      </View>

      {(phone || email || address) && <View style={styles.divider} />}

      <View style={styles.contactList} data-sentry-element="View" data-sentry-source-file="PersonalInfo.tsx">
        {birthday && <View style={styles.contactItem}>
            <View style={styles.contactIcon}>
              <PDFBirthdayIcon />
            </View>
            <Text style={styles.contactText}>
              {formatDateStringToMonthYear(birthday)}
            </Text>
          </View>}

        {phone && <View style={styles.contactItem}>
            <View style={styles.contactIcon}>
              <PDFPhoneIcon />
            </View>
            <Link style={styles.contactText} src={`tel:${phone}`}>
              {phone}
            </Link>
          </View>}

        {email && <View style={styles.contactItem}>
            <View style={styles.contactIcon}>
              <PDFEmailIcon />
            </View>
            <Link style={styles.contactText} src={`mailto:${email}`}>
              {email}
            </Link>
          </View>}

        {address && <View style={styles.contactItem}>
            <View style={styles.contactIcon}>
              <PDFLocationIcon />
            </View>
            <Text style={styles.contactText}>{address}</Text>
          </View>}
      </View>

      {/* Social links */}
      {info.links && !isEmptyValueArray(info.links) && <>
          <View style={styles.divider} />
          <View style={styles.socialLinks}>
            {info.links.map((item, index) => {
          const {
            id = '',
            url = '',
            name: linkName = ''
          } = item || {};
          const Icon = linkName ? getPDFSocialIcon(linkName) : SOCIAL_PLATFORMS.DEFAULT?.pdfIcon;
          return <View key={`social-${index}-${id}`}>
                  <View style={styles.socialItem}>
                    <View style={styles.socialIcon}>
                      {Icon ? <>
                          <Icon color={theme.colors.primary} />{' '}
                        </> : <PDFHrefIcon fill={theme.colors.primary} />}
                    </View>
                    {url ? <Link style={styles.socialText} src={url}>
                        {getSocialMediaIdentifier(url)}
                      </Link> : <Text style={{
                ...styles.socialText,
                textDecoration: 'none'
              }}>
                        [...]
                      </Text>}
                  </View>
                </View>;
        })}
          </View>
        </>}
    </View>;
};
export default PersonalInfoSection;